import axios from 'axios';
import rateLimit from 'axios-rate-limit';

const rateLimiter = rateLimit(axios, { maxRequests: 30, perMilliseconds: 1000, maxRPS: 30 });

export default rateLimiter;
